<template>
  <div class="footer-area-wrapper" :class="FooterStyle">
    <div class="footer-area section-space--ptb_90">
      <div class="container">
        <div class="row footer-widget-wrapper">
          <div class="col-lg-3 col-md-6 footer-widget">
            <ul class="footer-widget__list">
              <li>62 Fairview Westgate Harare</li>
              <li>
                <a href="mailto:info@hobbstech.co.zw" class="hover-style-link"
                  >info@hobbstech.co.zw</a
                >
              </li>
              <li>
                <a href="tel:+263778831917" class="hover-style-link">
                  (263) 778 831 917
                </a>
                &nbsp;/&nbsp;
                <a href="tel:+263715970126" class="hover-style-link">
                  (263) 715 970 126
                </a>
              </li>
              <li>
                <a href="/" class="hover-style-link hover-style-link--green"
                  >www.hobbstech.co.zw</a
                >
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20">Who we are</h6>
            <ul class="footer-widget__list">
              <li>
                <router-link :to="{ name: 'about-us' }" class="hover-style-link"
                  >About us
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'services' }" class="hover-style-link"
                  >Before you go
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'location' }"
                  class="hover-style-link"
                >
                  Where to Find Us
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20">Support</h6>
            <ul class="footer-widget__list">
              <li>
                <router-link
                  :to="{ name: 'contact-us' }"
                  class="hover-style-link"
                >
                  Contact us
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'faqs' }" class="hover-style-link">
                  FAQ
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20">Quick links</h6>
            <ul class="footer-widget__list">
              <li>
                <router-link :to="{ name: 'clients' }" class="hover-style-link">
                  Our Clients
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'partners' }"
                  class="hover-style-link"
                >
                  Our Partners
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'services' }"
                  class="hover-style-link"
                >
                  Our Services
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'products' }"
                  class="hover-style-link"
                >
                  Our Products
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright-area border-top section-space--ptb_30">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-left">
            <span class="copyright-text">
              &copy; {{ new Date().getFullYear() }} <b>HobbsTech</b> Made with
              <i class="fa fa-heart text-danger"></i> by
              <a href="#"><b>HobbsTech</b></a>
            </span>
          </div>
          <div class="col-md-6 text-center text-md-right">
            <ul class="list ht-social-networks solid-rounded-icon">
              <li class="item">
                <a
                  href="https://www.facebook.com/hobbstechint"
                  target="_blank"
                  class="social-link"
                >
                  <i class="fab fa-facebook social-link-icon"></i>
                </a>
              </li>
              <li class="item">
                <a
                  href="https://twitter.com/TechHobbs"
                  target="_blank"
                  class="social-link"
                >
                  <i class="fab fa-twitter social-link-icon"></i>
                </a>
              </li>
              <li class="item">
                <a
                  href="https://www.linkedin.com/company/hobbstech/"
                  target="_blank"
                  class="social-link"
                >
                  <i class="fab fa-linkedin social-link-icon"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright-area">
      <div class="container">
        <ul class="list ht-social-networks solid-rounded-icon">
          <li class="item">
            <a href="/terms-and-conditions">Terms & Conditions</a>
          </li>
          <li class="item">
            <a href="/privacy-policy">Privacy Policy</a>
          </li>
          <li class="item">
            <a href="/cookie-policy">Cookie Policy</a>
          </li>
          <li class="item">
            <a href="/return-policy">Return Policy</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterMain",
  props: ["FooterStyle"],
};
</script>
